import React, { useState } from 'react';
import styled from 'styled-components';
import { format } from 'date-fns';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import es from "date-fns/locale/es";

const modifiedEs = {
  ...es,
  localize: {
    ...es.localize,
    month: (monthIndex, options) => {
      const monthName = es.localize.month(monthIndex, options);
      return monthName.charAt(0).toUpperCase() + monthName.slice(1);
    },
  },
};

const FechaReporte = ({
    selectedDate,
    setSelectedDate
}) => {

  const [showCalendar, setShowCalendar] = useState(false);

  const handleDayClick = (date) => {
    setSelectedDate(date);
    setShowCalendar(false);
  };

  return (
    <DivContainer>
      <HorizontalBar onClick={() => setShowCalendar(!showCalendar)}>
        <DateText>{selectedDate ? format(selectedDate, 'dd/MM/yyyy') : 'Selecciona una fecha'}</DateText>
      </HorizontalBar>
      {showCalendar && (
        <FloatingCalendar>
          <DayPicker
                mode="single"
            selected={selectedDate}
            onDayClick={handleDayClick}
            locale={modifiedEs}
            globalStyle={`
            .DayPicker {
              font-family: 'Montserrat', sans-serif;
          
            }
       
          `}
          />
        </FloatingCalendar>
      )}
    </DivContainer>
  );
};

export default FechaReporte;

const DivContainer = styled.div`
  position: relative;
  width: auto;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  &:hover {
    background-color: #eae5e5;
  }
  b
`;

const HorizontalBar = styled.div`
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  padding: 8px 8px;
  cursor: pointer;
  border-radius: 8px;
  border: solid 2px #092a3f;
`;

const DateText = styled.span`
color: #003049;
font-family: 'Montserrat', sans-serif;
font-weight: 500;
font-size: 12px;
cursor: pointer;
transition: border-color 0.3s ease;
box-sizing: border-box;
`;

const FloatingCalendar = styled.div`
position: absolute;
top: calc(100% + 5px);
left: calc(-170%);
z-index: 10;
background-color: white;
box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.5);
border-radius: 8px;
padding:8px;
@media only screen and (min-width:0px) and (max-width:600px){
  left: 0;
  width:-webkit-fill-available;
}
`;
